<template>
  <div v-if="!item.meta || !item.meta.hidden">
    <!-- 有子菜单 -->
    <el-submenu
      v-if="hasChildren"
      :index="resolvePath(item.path)"
      :popper-append-to-body="false"
    >
      <template slot="title">
        <i v-if="item.meta && item.meta.icon" :class="item.meta.icon"></i>
        <span>{{ item.meta ? item.meta.title : '数据分析' }}</span>
      </template>
      <sidebar-item
        v-for="child in visibleChildren"
        :key="child.path"
        :item="child"
        :base-path="resolvePath(item.path)"
      />
    </el-submenu>

    <!-- 单个菜单 -->
    <el-menu-item v-else :index="resolvePath(item.path)">
      <i v-if="item.meta && item.meta.icon" :class="item.meta.icon"></i>
      <span slot="title">{{ item.meta ? item.meta.title : '' }}</span>
    </el-menu-item>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  computed: {
    visibleChildren() {
      
      return this.item.children ? this.item.children.filter(child => !child.meta?.hidden) : []
    },
    hasChildren() {
      return this.visibleChildren.length > 0
    }
  },
  methods: {
    resolvePath(routePath) {
      if (this.isExternalLink(routePath)) {
        return routePath
      }
      if (this.isExternalLink(this.basePath)) {
        return this.basePath
      }
      // 如果 routePath 是绝对路径，直接返回
      if (routePath.startsWith('/')) {
        return routePath
      }
      // 拼接路径
      const base = this.basePath.endsWith('/') ? this.basePath.slice(0, -1) : this.basePath
      const resolved = `${base}/${routePath}`.replace(/\/+/g, '/')
      // 调试日志（可在浏览器控制台查看）
      if (process.env.NODE_ENV === 'development') {
        console.log(`[SidebarItem] basePath: ${this.basePath}, routePath: ${routePath}, resolved: ${resolved}`)
      }
      return resolved
    },
    isExternalLink(path) {
      return /^(https?:|mailto:|tel:)/.test(path)
    }
  }
}
</script>

